/**
 * @generated SignedSource<<ad19842f6c0a98b10c1534069fb63561>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type LabelType = "DOMINANT_COLOR" | "HEADLINE" | "HOOK_TEXT" | "IMAGE" | "NOUN" | "PHRASE" | "TAG" | "THEME" | "VERB" | "VIDEO" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type ThemeInsight_InsightV2$data = {
  readonly clusteredSublabels: ReadonlyArray<{
    readonly labelLift: number;
    readonly labelName: string;
    readonly labelType: LabelType;
  }> | null;
  readonly delta: number | null;
  readonly id: string | null;
  readonly labelName: string | null;
  readonly rateWhenAbsent: number | null;
  readonly " $fragmentType": "ThemeInsight_InsightV2";
};
export type ThemeInsight_InsightV2$key = {
  readonly " $data"?: ThemeInsight_InsightV2$data;
  readonly " $fragmentSpreads": FragmentRefs<"ThemeInsight_InsightV2">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "labelName",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ThemeInsight_InsightV2",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "delta",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "rateWhenAbsent",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ClusteredSublabel",
      "kind": "LinkedField",
      "name": "clusteredSublabels",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "labelLift",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "labelType",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "InsightV2",
  "abstractKey": null
};
})();

(node as any).hash = "246d3da891da6afac97dbcb919b5408f";

export default node;
